// Task → model policy, the client half of the backend's AIServices/model_policy.py.
//
// All five dropdown models are now wired for every task — no Luna fallback.
// Previously Luna only covered plain chat and unsupported tasks fell back to gpt-4o-mini;
// now gpt-6-luna, gpt-4o-mini, mistral-7b, claude-haiku-5-5 and gemini-3.5-flash all
// pass through verbatim for every task (correction, summary, blog, rag, simulator, etc.).
// Backend enforces the same rule; frontend keeps wire request correct up front.
//
// AWS Bedrock migration: 3/5 are natively on Bedrock, 2 require fallback (see BEDROCK_IDS).

export const LUNA_MODEL = 'gpt-6-luna';
export const DEFAULT_MODEL = 'gemini-3.5-flash';
export const FALLBACK_MODEL = 'gpt-4o-mini';

// --- AWS Bedrock IDs ( mantl / runtime ) ---
// gpt-6-luna: GA on Bedrock 2026-09-22 - https://docs.aws.amazon.com/bedrock/latest/userguide/model-card-openai-gpt-6-luna.html
//   mantle: openai.gpt-6-luna (us-east-1 in-region) | runtime: us.openai.gpt-6-luna / global.openai.gpt-6-luna
export const LUNA_BEDROCK_ID = 'openai.gpt-6-luna';
export const LUNA_BEDROCK_GEO_ID = 'us.openai.gpt-6-luna';
export const LUNA_BEDROCK_GLOBAL_ID = 'global.openai.gpt-6-luna';

// AWS Bedrock managed Mistral 7B — wired for every task
// Bedrock modelId: mistral.mistral-7b-instruct-v0:2  (alias: mistral-7b for UI)
export const MISTRAL_7B_MODEL = 'mistral.mistral-7b-instruct-v0:2';
export const MISTRAL_7B_ALIAS = 'mistral-7b';

// AWS Bedrock managed Claude 3.5 Haiku — alias claude-haiku-5-5 as requested
// Bedrock id: anthropic.claude-3-5-haiku-20241022-v1:0, aliases: claude-3-5-haiku-20241022 / claude-haiku-3-5 / claude-haiku-5-5
// Note: claude-haiku-5-5 is UI alias for same Bedrock 3.5 Haiku; Bedrock Haiku 5.5 not yet listed separately.
export const CLAUDE_HAIKU_35_MODEL = 'anthropic.claude-3-5-haiku-20241022-v1:0';
export const CLAUDE_HAIKU_35_ALIAS = 'claude-3-5-haiku-20241022';
export const CLAUDE_HAIKU_35_SHORT = 'claude-haiku-3-5';
export const CLAUDE_HAIKU_55_ALIAS = 'claude-haiku-5-5';

// Amazon Nova Canvas for image generation — Bedrock image model
export const NOVA_CANVAS_MODEL = 'amazon.nova-canvas-v1:0';
export const NOVA_CANVAS_LABEL = 'Amazon Nova Canvas';

// Bedrock mapping for all 5 UI aliases -> Bedrock modelId (or null if not on Bedrock)
// gpt-6-luna + mistral-7b + claude-haiku-5-5 are native Bedrock
// gpt-4o-mini NOT on Bedrock (no openai.gpt-4o-mini) — closest is openai.gpt-6-luna / openai.gpt-5.6-luna
// gemini-3.5-flash NOT on Bedrock (Google) — no Bedrock equivalent, keep via Google API
export const BEDROCK_IDS = {
  'gpt-6-luna': LUNA_BEDROCK_ID,
  'mistral-7b': MISTRAL_7B_MODEL,
  'claude-haiku-5-5': CLAUDE_HAIKU_35_MODEL,
  'gpt-4o-mini': null, // use LUNA_BEDROCK_ID as fallback if forcing Bedrock-only
  'gemini-3.5-flash': null,
  [NOVA_CANVAS_MODEL]: NOVA_CANVAS_MODEL,
};

// Helper: resolve UI alias to Bedrock ID (null = not on Bedrock, keep original provider)
export function bedrockIdForModel(model) {
  return BEDROCK_IDS[model] ?? null;
}

export const ALLOWED_MODELS = ['gpt-6-luna', 'gpt-4o-mini', 'mistral-7b', 'claude-haiku-5-5', 'gemini-3.5-flash'];

// All five are wired for every task — Luna no longer has unsupported tasks.
export function lunaSupports(task) {
  return true;
}

// Picks the model to send for a task: every allowed model passes through verbatim.
// Luna fallback kept for backwards compat but never triggers now.
export function modelForTask(model, task) {
  return model;
}
